<div class="main d-flex flex-column">
  <div class="nec-tabs">
    <button *ngFor="let tab of tabs" [class.selected]="selectedTabId === tab.substationTemplateId"
      (click)="switchTab(tab)">
      <span>{{ tab.substationTemplateName }}</span>
      <div class="num-of-instatiations" [class.selected]="selectedTabId === tab.substationTemplateId">
        {{ tab.count }}
      </div>
    </button>
  </div>
  <div class="filters d-flex align-items-center gap-3">
    <div class="filter-button-container">
      <button class="d-flex gap-3 align-items-center" (click)="filterOpened = !filterOpened">
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 3.75H14M6 14.25H10M4 9H12" stroke="#171717" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <span>Filter</span>
      </button>
      <div *ngIf="filterOpened" class="filters-window">
                <lib-nec-filter 
                    [regions]="geoRegions" 
                    [allAreas]="allSubGeoRegions"
                    [filter]="filter"
                    (applyFilter)="onFilterApplied()"
                ></lib-nec-filter>
      </div>
    </div>
    <div class="search-filter d-flex align-items-center">
      <div class="search-type d-flex gap-2 align-items-center" (click)="searchDropdownOpened = !searchDropdownOpened">
                <span>{{ filter.searchType === SearchType.Name ? 'Asset Name' : 'Asset Number' }}</span>
        <img height="12" width="12" src="../../../../assets/icons/arrow-down-small.svg" />
      </div>
      <div class="search-bar">
        <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon" />
                <input
                  type="text"
                  placeholder="Search"
                  [(ngModel)]="filter.searchValue"
                  (keydown.enter)="getSubstationTemplateInstances()"
                />
      </div>
      <div *ngIf="searchDropdownOpened" class="search-dropdown">
        <ul>
                   <li (click)="selectSearchType(SearchType.Name)">Asset Name</li> 
                   <li (click)="selectSearchType(SearchType.Number)">Asset Number</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="d-flex align-items-center gap-3">
            <input class="checkbox" type="checkbox" />
            <span>
              Name
            </span>
          </th>
          <th>Asset Number</th>
          <th>Electrical Address</th>
          <th>Region & District</th>
          <th>Meter Number</th>
          <th>Meter Brand</th>
          <th></th>
        </tr>
      </thead>
      
      <tbody>
        <tr *ngFor="let substationTemplateInstance of substationTemplateInstances">
          <td class="d-flex align-items-center h-100">
            <div class="cell-content" (click)="openDetails(substationTemplateInstance)">
              <input class="checkbox" type="checkbox" (click)="$event.stopImmediatePropagation()" />
              <span>{{ substationTemplateInstance.name | hasValue | uppercase }}</span>
            </div>
          </td>
          <td>
            <div class="cell-content" (click)="openDetails(substationTemplateInstance)">
              <span class="span-padding">
                {{ substationTemplateInstance.number | hasValue | uppercase}}
              </span>
            </div>
          </td>
          <td>
            <div class="cell-content" (click)="openDetails(substationTemplateInstance)">
              <!-- currently Electrical Address is '------' until said otherwise -->
              <span class="span-padding">
                ----
              </span>
            </div>
          </td>
          <td>
            <div class="cell-content and-cells" (click)="openDetails(substationTemplateInstance)">
              <div class="d-flex flex-column gap-1">
                <span>{{ substationTemplateInstance.subGeographicalRegion?.geographicalRegion.name | hasValue |
                  uppercase }}</span>
                <span class="gray-text">{{ substationTemplateInstance.subGeographicalRegion?.name | hasValue }}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="cell-content" (click)="openDetails(substationTemplateInstance)">
              <span class="span-padding">
                {{ substationTemplateInstance.meterNumber | hasValue | uppercase }}
              </span>
            </div>
          </td>
          <td>
            <div class="cell-content" (click)="openDetails(substationTemplateInstance)">
              <span class="span-padding">
                {{ substationTemplateInstance.meterBrand | hasValue }}
              </span>
            </div>
          </td>
          <td class="menu-cell">
            <div *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed || permissionsService.isNetworkEntityClassesDeleteAllowed" class="menu-wrapper cell-content dots-padding">
              <div class="dots" (click)="toggleActionMenu(substationTemplateInstance, $event)">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.43647 7.16337L6.15006 9.19769C6.76771 9.6607 7.65378 9.4528 8.00108 8.76344C8.16304 8.44191 8.45676 8.20667 8.80589 8.11883L10.3201 7.73791C11.3039 7.49041 12.0717 6.72137 12.3173 5.7371L13.0568 2.77495M3.43647 7.16337C2.8501 8.31607 2.51953 9.62073 2.51953 11.0026C2.51953 15.6855 6.31579 19.4818 10.9987 19.4818C15.6816 19.4818 19.4779 15.6855 19.4779 11.0026C19.4779 7.02949 16.7452 3.69461 13.0568 2.77495M3.43647 7.16337C4.8372 4.4098 7.69766 2.52344 10.9987 2.52344C11.7085 2.52344 12.3979 2.61065 13.0568 2.77495" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.9051 15.5843C13.4236 15.5843 13.8975 15.2915 14.1294 14.8277C14.4373 14.2121 14.2399 13.4635 13.6685 13.0795L12.5205 12.3081C12.157 12.0638 11.7351 11.9204 11.2979 11.8925L10.6919 11.8539C10.3692 11.8332 10.0531 11.9522 9.82404 12.1805C9.44262 12.5605 9.38294 13.1572 9.68168 13.6052L10.2932 14.5225C10.7355 15.1859 11.48 15.5843 12.2773 15.5843H12.9051Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="popup-menu" libPopupMenuFlip *ngIf="actionMenuOpenForId === substationTemplateInstance.id">
                <button *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed" class="menu-item" data-bs-toggle="modal" data-bs-target="#editAddModal-0"
                  (click)="selectSubstation(substationTemplateInstance)">
                  Update
                </button>
                <button class="menu-item"
                    (click)="viewHistory(substationTemplateInstance.substationId)"
                    data-bs-toggle="modal" data-bs-target="#substationHistory">
                  History
                </button>
                <button *ngIf="permissionsService.isNetworkEntityClassesDeleteAllowed" class="menu-item" data-bs-toggle="modal" data-bs-target="#deleteSs">
                  Remove
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="bv-pagination py-4">
    <lib-pagination-new [totalItems]="count" [pageSize]="pageSize" [currentPage]="currentPage" [pageSizes]="pageSizes"
      (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
    </lib-pagination-new>
  </div>
</div>

<div class="modal fade" id="deleteSs" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="deleteBuTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.SUBSTATION" | translate }}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button type="button" class="btn btn-primary" (click)="onRemove()" data-bs-dismiss="modal">
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editAddModal-0" tabindex="-1" aria-labelledby="exampleEditModalLabel" aria-hidden="true">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()" style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="exampleEditModalLabel">{{ isEdit ? "Update Substation" : "Add New Substation" }}</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal"
          aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05" />
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07" />
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5"
              stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <p class="description-text">{{ isEdit ? "Fill out the fields carefully to update this instance, including all necessary information for identification." : "Fill out the fields carefully to create a new instance, including all necessary information for identification." }}</p>
      <div
        class="nec-substation-scroll new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Instance Category</p>
          </div>
          <div class="col-6">
            <lib-object-dropdown [items]="substationTemplatesForSelect" [displayField]="'className'"
              [initialValue]="substationTemplateValue" (valueChange)="onSelectSubstationTemplate($event)"
              [disabled]="isEdit" [isRequired]="true" #dropdownInstance></lib-object-dropdown>
          </div>
        </div>
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Asset Name</p>
          </div>
          <div class="col-6 mb-3">
            <input class="new-instance-input w-100" type="text" name="code" placeholder=" "
              [(ngModel)]="substationForSave.name" />
          </div>
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Asset Number</p>
          </div>
          <div class="col-6">
            <input class="new-instance-input w-100" type="text" name="number" placeholder=" "
              [(ngModel)]="substationForSave.number" />
          </div>
        </div>
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Base Voltage</p>
          </div>
          <div class="col-6">
            <lib-object-dropdown [items]="baseVoltages" [displayField]="'name'" [initialValue]="baseVoltageValue"
              (valueChange)="onSelectBaseVoltage($event)" [disabled]="false" [isRequired]="true"
              #dropdownVoltage></lib-object-dropdown>
          </div>
        </div>
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Meter Number</p>
          </div>
          <div class="col-6 mb-3">
            <input class="new-instance-input w-100" type="text" name="meterNumber" placeholder=" "
              [(ngModel)]="substationForSave.meterNumber" />
          </div>
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Meter Brand</p>
          </div>
          <div class="col-6">
            <lib-object-dropdown [items]="meterBrands" [displayField]="'name'" [initialValue]="meterBrandValue"
              (valueChange)="onSelectMeterBrand($event)" [disabled]="false" [placeholder]="'Select Meter Brand'"
              #dropdownMeterBrand></lib-object-dropdown>
          </div>
        </div>
        <div class="section w-100 row pb-3">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Parent Substation Connection</p>
          </div>
          <div class="connectivity col-6 mb-4 pb-2">
            CONNECTIVITY
          </div>
          <div style="display: flex; flex-wrap: wrap; padding: 0;">
            <div *ngIf="showParentSubstationDropdowns" class="col-6"></div>

            <div *ngIf="showParentSubstationDropdowns" class="col-6 mb-3" style="padding: 0 7.5px;">
              <lib-object-dropdown [items]="parentSubstations" [displayField]="'name'"
                (valueChange)="onSelectParentSubstation($event)" [placeholder]="'Select Substation'" [isRequired]="true"
                [isSearchEnabled]="true" [maxDisplayItemSize]="10"
                (searchTextChange)="onSearchTextChange($event)" #dropdownParentSubstation></lib-object-dropdown>
            </div>

            <div *ngIf="showParentSubstationDropdowns" class="col-6"></div>

            <div *ngIf="showParentSubstationDropdowns" class="col-6 mb-3" style="padding: 0 7.5px;">
              <lib-object-dropdown [items]="outgoingAcLineSegments" [displayField]="'name'"
                (valueChange)="onSelectAcLineOutoging($event)" [disabled]="updatedParentSubstationId === null"
                [placeholder]="'Select Ac Line Segment'" [isRequired]="true" #dropdownAcLineOutgoing></lib-object-dropdown>
            </div>
          </div>
          <div *ngIf="!(substationForSave.parentSubstations && substationForSave.parentSubstations.length > 0)"
            class="col-6"></div>
          <div *ngIf="!(substationForSave.parentSubstations && substationForSave.parentSubstations.length > 0)"
            class="outgoing-div col-6 mb-4 pb-4">
            <input class="outgoing-input w-100" type="text" name="outgoingAcLines"
              placeholder="                No outgoing added yet" disabled />
          </div>
          <span *ngFor="let acLineOutoging of addedAcLinesOutgoing" class="d-flex" style="padding-right: 1.4rem;">
            <div class="col-6"></div>
            <div class="col-6 d-flex justify-content-between align-items-center ac-line-label">
              {{acLineOutoging.acLineName}}
              <button *ngIf="!acLineOutoging.isExisting" type="button" class="ac-line-delete-btn"
                (click)="removeFromLists(acLineOutoging.acLineId);  $event.stopPropagation()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.16406 4.33594L3.76748 12.9293C3.81652 13.6277 4.3974 14.1693 5.09753 14.1693H10.8973C11.5974 14.1693 12.1783 13.6277 12.2273 12.9293L12.8307 4.33594"
                    stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2.16406 3.83594H13.8307" stroke="#171717" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M5.67969 3.71932C5.81715 2.56174 6.80202 1.66406 7.99662 1.66406C9.19122 1.66406 10.1761 2.56174 10.3136 3.71932"
                    stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </span>
          <div class="col-6"></div>
          <div class="col-6">
            <button type="button" class="add-substation-bttn" (click)="addParentSubstation()">
              Add Substation
            </button>
          </div>
        </div>
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Geographical Boundary</p>
          </div>
          <div class="col-6 mb-3">
            <lib-object-dropdown [items]="geoRegions" [displayField]="'name'" [initialValue]="geographicalRegionValue"
              (valueChange)="onSelectGeographicalRegion($event)" [disabled]="false" [isRequired]="true"
              [placeholder]="'Select Region'" #dropdownRegion></lib-object-dropdown>
          </div>
          <div class="col-6"></div>
          <div class="col-6">
            <lib-object-dropdown [items]="subGeoRegions" [displayField]="'name'"
              [initialValue]="subGeographicalRegionValue" (valueChange)="onSelectSubGeographicalRegion($event)"
              [disabled]="updatedRegionId === null" [isRequired]="true" [placeholder]="'Select District'"
              #dropdownDistrict></lib-object-dropdown>
          </div>
        </div>
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Supplied Region</p>
          </div>
          <div class="col-6 mb-3">
            <input class="supplied-region-input w-100" type="text" name="suppliedRegion" placeholder=" "
              [(ngModel)]="suppliedRegionName" [ngModel]="suppliedRegionName | uppercase" disabled />
          </div>
          <div class="col-6"></div>
          <div class="col-6">
            <input class="supplied-region-input w-100" type="text" name="suppliedDistrict" placeholder=" "
              [(ngModel)]="suppliedDistrictName" disabled />
          </div>
        </div>
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Latitude</p>
          </div>
          <div class="col-6 mb-3">
            <input class="new-instance-input w-100" type="number" name="latitude" placeholder=" "
              [(ngModel)]="substationForSave.latitude"
              [disabled]="selectedSubstation?.isEnumerated && selectedSubstation.latitude != null && selectedSubstation.longitude != null" />
          </div>
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Longitude</p>
          </div>
          <div class="col-6">
            <input class="new-instance-input w-100" type="number" name="longitude" placeholder=" "
              [(ngModel)]="substationForSave.longitude"
              [disabled]="selectedSubstation?.isEnumerated && selectedSubstation.latitude != null && selectedSubstation.longitude != null" />
          </div>
        </div>
      </div>
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal>Cancel</button>
        <button type="submit" class="btn save-modal-btn">Save</button>
      </div>
    </form>
  </div>
</div>

<lib-nec-substation-details *ngIf="isDetailsOpen" [data]="substationDetails" (closed)="isDetailsOpen = false"
  (saveOrDeleteSuccess)="closeDetailsAndRefresh($event)"
  [autoOpenSchematic]="autoOpenSchematicOnDetails"
  (autoOpenSchematicHandled)="onAutoOpenSchematicHandled()"></lib-nec-substation-details>

<lib-nec-upload-modal-power-transformer
 [hidden]="!uploadModalOpened" [uploadType]="UploadFileType" [substationTemplateId]="selectedTabId">
</lib-nec-upload-modal-power-transformer>

<div class="modal fade" id="substationHistory" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered substation-history-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Update History</h5>
                <button type="button" class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
            </div>
            <div class="modal-body substation-history-body">
                <table class="substation-history-table">
                    <thead>
                        <tr class="header-row">
                            <th>Timestamp</th>
                            <th>Changed By</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Name <span class="sub-header">Prev / New</span></th>
                            <th>Number <span class="sub-header">Prev / New</span></th>
                            <th>District <span class="sub-header">Prev / New</span></th>
                            <th>Incoming AC Lines <span class="sub-header">Prev / New</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="content-wrapper" *ngFor="let item of substationHistoryItems">
                            <td>{{ item.timestamp | date : "dd/MM/yyyy HH:mm:ss" | hasValue }}</td>
                            <td>{{ item.user | hasValue }}</td>
                            <td>{{ item.userEmail | hasValue }}</td>
                            <td>{{ item.userRole | hasValue }}</td>
                            <td>
                                <ng-container *ngIf="item.previousName != null || item.newName != null; else nameNcSs">
                                    <span class="prev-value">{{ item.previousName }}</span>
                                    <span class="new-value">{{ item.newName }}</span>
                                </ng-container>
                                <ng-template #nameNcSs><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousNumber != null || item.newNumber != null; else numberNcSs">
                                    <span class="prev-value">{{ item.previousNumber }}</span>
                                    <span class="new-value">{{ item.newNumber }}</span>
                                </ng-container>
                                <ng-template #numberNcSs><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousSubGeographicalRegion != null || item.newSubGeographicalRegion != null; else subGeoNcSs">
                                    <span class="prev-value">{{ item.previousSubGeographicalRegion }}</span>
                                    <span class="new-value">{{ item.newSubGeographicalRegion }}</span>
                                </ng-container>
                                <ng-template #subGeoNcSs><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousIncomingACLines != null || item.newIncomingACLines != null; else acLinesNcSs">
                                    <span class="prev-value">{{ item.previousIncomingACLines }}</span>
                                    <span class="new-value">{{ item.newIncomingACLines }}</span>
                                </ng-container>
                                <ng-template #acLinesNcSs><span class="not-changed">Not changed</span></ng-template>
                            </td>
                        </tr>
                        <tr *ngIf="substationHistoryItems.length === 0">
                            <td class="no-history" colspan="8">No history available</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>